import { getPatientAllergiesByUserId } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type { PatientAllergyT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchPatientAllergiesByUserId(
  userId: string,
  signal?: AbortSignal
): Promise<PatientAllergyT[]> {
  const config = await createLotusRequestConfig({ signal });
  const response = await getPatientAllergiesByUserId(userId, config);
  return lotusHealthZod.getPatientAllergiesByUserIdResponse.parse(
    response.data
  ) as PatientAllergyT[];
}
